import React from 'react';
import '../styles/LoadingSpinner.css';

const LoadingSpinner = ({ 
  message = 'Yükleniyor...', 
  fullPage = false,
  size = 'medium' // 'small', 'medium', 'large'
}) => {
  const sizeClasses = {
    small: { paw: 24, gap: 2, container: 'px-6 py-4' },
    medium: { paw: 36, gap: 4, container: 'px-10 py-7' },
    large: { paw: 48, gap: 6, container: 'px-14 py-10' }
  };

  const currentSize = sizeClasses[size];

  if (fullPage) {
    return (
      <div className="kito-loading-fullpage">
        {/* Decorative floating icons */}
        <div className="kito-loading-float-icon kito-loading-cat-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 12 L6 6 L9 12" stroke="white" strokeWidth="2" fill="none" />
            <path d="M15 12 L18 6 L21 12" stroke="white" strokeWidth="2" fill="none" />
            <circle cx="12" cy="14" r="8" fill="white" />
            <circle cx="9" cy="13" r="1.5" fill="#ff9800" />
            <circle cx="15" cy="13" r="1.5" fill="#ff9800" />
            <path d="M12 15 Q10 17 8 16 M12 15 Q14 17 16 16" stroke="#ff9800" strokeWidth="1.5" fill="none" />
          </svg>
        </div>
        <div className="kito-loading-float-icon kito-loading-float-delayed kito-loading-dog-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 8 L8 4 L10 8" stroke="white" strokeWidth="2" fill="white" />
            <path d="M14 8 L16 4 L18 8" stroke="white" strokeWidth="2" fill="white" />
            <circle cx="12" cy="14" r="8" fill="white" />
            <circle cx="9" cy="13" r="1.5" fill="#764ba2" />
            <circle cx="15" cy="13" r="1.5" fill="#764ba2" />
            <ellipse cx="12" cy="16" rx="1" ry="1.5" fill="#764ba2" />
            <path d="M12 17 L12 19" stroke="#764ba2" strokeWidth="1.5" />
            <path d="M12 19 Q9 20 7 18 M12 19 Q15 20 17 18" stroke="#764ba2" strokeWidth="1.5" fill="none" />
          </svg>
        </div>

        <div className="kito-loading-content">
          {/* Logo/Brand Name */}
          <div className="kito-loading-brand mb-4">
            <h1 className="kito-loading-brand-name">kito.pet</h1>
            <div className="kito-loading-tagline">
              <span>🐱</span>
              <span>FOR CATS & DOGS</span>
              <span>🐶</span>
            </div>
          </div>

          {/* Paw Print Spinner */}
          <div className={`kito-loading-spinner-container ${currentSize.container} mb-4`}>
            {/* Dog Paw */}
            <svg className="kito-loading-paw kito-loading-paw-1" width={currentSize.paw} height={currentSize.paw} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="12" cy="18" rx="3.5" ry="4.5" fill="white" />
              <ellipse cx="7" cy="12" rx="2" ry="3" fill="white" transform="rotate(-20 7 12)" />
              <ellipse cx="11" cy="10" rx="2" ry="3" fill="white" />
              <ellipse cx="13" cy="10" rx="2" ry="3" fill="white" />
              <ellipse cx="17" cy="12" rx="2" ry="3" fill="white" transform="rotate(20 17 12)" />
            </svg>

            {/* Cat Paw */}
            <svg className="kito-loading-paw kito-loading-paw-2" width={currentSize.paw} height={currentSize.paw} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="12" cy="17" rx="2.5" ry="3.5" fill="#ff9800" />
              <circle cx="8" cy="12" r="1.8" fill="#ff9800" />
              <circle cx="12" cy="10" r="1.8" fill="#ff9800" />
              <circle cx="16" cy="12" r="1.8" fill="#ff9800" />
            </svg>

            {/* Dog Paw */}
            <svg className="kito-loading-paw kito-loading-paw-3" width={currentSize.paw} height={currentSize.paw} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="12" cy="18" rx="3.5" ry="4.5" fill="white" />
              <ellipse cx="7" cy="12" rx="2" ry="3" fill="white" transform="rotate(-20 7 12)" />
              <ellipse cx="11" cy="10" rx="2" ry="3" fill="white" />
              <ellipse cx="13" cy="10" rx="2" ry="3" fill="white" />
              <ellipse cx="17" cy="12" rx="2" ry="3" fill="white" transform="rotate(20 17 12)" />
            </svg>

            {/* Cat Paw */}
            <svg className="kito-loading-paw kito-loading-paw-4" width={currentSize.paw} height={currentSize.paw} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="12" cy="17" rx="2.5" ry="3.5" fill="#ff9800" />
              <circle cx="8" cy="12" r="1.8" fill="#ff9800" />
              <circle cx="12" cy="10" r="1.8" fill="#ff9800" />
              <circle cx="16" cy="12" r="1.8" fill="#ff9800" />
    </svg>
          </div>

          {/* Loading Text */}
          <p className="kito-loading-text">{message}</p>
        </div>
      </div>
    );
  }

  // Inline version (for smaller loading states)
  return (
    <div className="kito-loading-inline d-flex flex-column align-items-center justify-content-center p-4">
      <div className={`kito-loading-spinner-container kito-loading-spinner-inline ${currentSize.container} mb-3`}>
        <svg className="kito-loading-paw kito-loading-paw-1" width={currentSize.paw} height={currentSize.paw} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="12" cy="18" rx="3.5" ry="4.5" fill="currentColor" />
          <ellipse cx="7" cy="12" rx="2" ry="3" fill="currentColor" transform="rotate(-20 7 12)" />
          <ellipse cx="11" cy="10" rx="2" ry="3" fill="currentColor" />
          <ellipse cx="13" cy="10" rx="2" ry="3" fill="currentColor" />
          <ellipse cx="17" cy="12" rx="2" ry="3" fill="currentColor" transform="rotate(20 17 12)" />
        </svg>
        <svg className="kito-loading-paw kito-loading-paw-2" width={currentSize.paw} height={currentSize.paw} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ filter: 'drop-shadow(0 0 8px rgba(255, 152, 0, 0.6)) drop-shadow(0 0 12px rgba(255, 152, 0, 0.4))' }}>
          <ellipse cx="12" cy="17" rx="2.5" ry="3.5" fill="#ff9800" />
          <circle cx="8" cy="12" r="1.8" fill="#ff9800" />
          <circle cx="12" cy="10" r="1.8" fill="#ff9800" />
          <circle cx="16" cy="12" r="1.8" fill="#ff9800" />
        </svg>
        <svg className="kito-loading-paw kito-loading-paw-3" width={currentSize.paw} height={currentSize.paw} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="12" cy="18" rx="3.5" ry="4.5" fill="currentColor" />
          <ellipse cx="7" cy="12" rx="2" ry="3" fill="currentColor" transform="rotate(-20 7 12)" />
          <ellipse cx="11" cy="10" rx="2" ry="3" fill="currentColor" />
          <ellipse cx="13" cy="10" rx="2" ry="3" fill="currentColor" />
          <ellipse cx="17" cy="12" rx="2" ry="3" fill="currentColor" transform="rotate(20 17 12)" />
        </svg>
        <svg className="kito-loading-paw kito-loading-paw-4" width={currentSize.paw} height={currentSize.paw} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ filter: 'drop-shadow(0 0 8px rgba(255, 152, 0, 0.6)) drop-shadow(0 0 12px rgba(255, 152, 0, 0.4))' }}>
          <ellipse cx="12" cy="17" rx="2.5" ry="3.5" fill="#ff9800" />
          <circle cx="8" cy="12" r="1.8" fill="#ff9800" />
          <circle cx="12" cy="10" r="1.8" fill="#ff9800" />
          <circle cx="16" cy="12" r="1.8" fill="#ff9800" />
        </svg>
      </div>
      {message && <p className="kito-loading-text-inline text-muted fw-medium mb-0">{message}</p>}
    </div>
  );
};

export default LoadingSpinner; 
